'use client'

import * as React from 'react'

import type { MediaType } from './types'

interface HeaderBlockFields {
  blockType: 'header'
  backgroundImage: MediaType | string
}

interface HeaderBlockProps {
  fields: HeaderBlockFields
}

export function HeaderBlock({ fields }: HeaderBlockProps) {
  const media = typeof fields.backgroundImage === 'string' ? null : fields.backgroundImage

  if (!media?.url) return null

  return (
    <div className='ui:relative ui:my-6 ui:h-64 ui:w-full ui:overflow-hidden ui:rounded-xl ui:md:h-80'>
      <img src={media.url} alt={media.alt ?? ''} className='ui:object-cover' loading='lazy' data-zoom />
      <div className='ui:from-neutral-black/60 ui:absolute ui:inset-0 ui:bg-linear-to-t ui:to-transparent' />
    </div>
  )
}
